import React, { useState } from "react";
import { googleSignUp } from "../services/googleSignUp";
import { appleSignIn } from "../services/appleSignIn";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import Loader from "../components/UI/loader";

function SignUp() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const isIOS = Capacitor.getPlatform() === "ios";

  function signin() {
    googleSignUp(navigate, setLoading);
  }

  function signinWithApple() {
    appleSignIn(navigate, setLoading);
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface px-6">
      <Loader loading={loading} />
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <img
            src="logo.png"
            alt="WaitLessQ"
            className="w-16 h-16 rounded-2xl mx-auto mb-4"
          />
          <h1 className="text-2xl font-bold text-gray-900">WaitLessQ</h1>
          <p className="text-sm text-gray-500 mt-2">
            Manage your business queue effortlessly
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-card p-6 flex flex-col gap-3">
          <button
            onClick={signin}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-gray-50 hover:bg-gray-100 rounded-xl py-3.5 px-4 border border-gray-200 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <img src="images/google.jpg" className="w-5 h-5" alt="Google" />
            <span className="text-sm font-semibold text-gray-700">
              Sign in with Google
            </span>
          </button>

          {isIOS && (
            <>
              <button
                onClick={signinWithApple}
                disabled={loading}
                className="w-full flex items-center justify-center gap-3 bg-black hover:bg-gray-900 rounded-xl py-3.5 px-4 disabled:opacity-60 disabled:cursor-not-allowed"
              >
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.4c1.3.07 2.22.73 2.98.78.98-.2 1.92-.84 3.12-.72 1.34.16 2.34.73 3 1.94-2.64 1.56-1.96 5.06.88 6.03-.57 1.56-1.3 3.1-1.98 4.85zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
                </svg>
                <span className="text-sm font-semibold text-white">
                  Sign in with Apple
                </span>
              </button>
            </>
          )}

          <div className="flex items-center gap-2">
            <div className="flex-1 h-px bg-gray-100" />
            <span className="text-xs text-gray-400">or</span>
            <div className="flex-1 h-px bg-gray-100" />
          </div>

          <button
            onClick={() => navigate("/waiter-login")}
            disabled={loading}
            className="w-full flex items-center justify-center gap-3 bg-primary-bg hover:bg-purple-100 rounded-xl py-3.5 px-4 border border-primary/20 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <svg className="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            <span className="text-sm font-semibold text-primary">
              Waiter PIN Login
            </span>
          </button>
        </div>

        <p className="text-xs text-gray-400 text-center mt-8">
          By signing in, you agree to our terms of service
        </p>
      </div>
    </div>
  );
}

export default SignUp;
